/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Create_Incomplete_Confirm_ActionInputs */

const en_case_create_incomplete_confirm_action = /** @type {(inputs: Case_Create_Incomplete_Confirm_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create anyway`)
};

const pt_br2_case_create_incomplete_confirm_action = /** @type {(inputs: Case_Create_Incomplete_Confirm_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar mesmo assim`)
};

/**
* | output |
* | --- |
* | "Create anyway" |
*
* @param {Case_Create_Incomplete_Confirm_ActionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_create_incomplete_confirm_action = /** @type {((inputs?: Case_Create_Incomplete_Confirm_ActionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Create_Incomplete_Confirm_ActionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_create_incomplete_confirm_action(inputs)
	return pt_br2_case_create_incomplete_confirm_action(inputs)
});